@if (hasErrored()) {
  <div class="invalid-data-text">
    {{ 'global.dataLoadError' | translate }}
  </div>
} @else if (noDataToDisplay()) {
  <div class="invalid-data-text">{{ 'charts.noData' | translate }}</div>
} @else {
  @if (chartOptions) {
    <div class="chart-container">
      <apx-chart
        [series]="chartOptions.series"
        [chart]="chartOptions.chart"
        [xaxis]="chartOptions.xaxis"
        [yaxis]="chartOptions.yaxis"
        [dataLabels]="chartOptions.dataLabels"
        [grid]="chartOptions.grid"
        [stroke]="chartOptions.stroke"
        [legend]="chartOptions.legend"
        [fill]="chartOptions.fill"
        [tooltip]="chartOptions.tooltip"
        [markers]="chartOptions.markers"
      ></apx-chart>
    </div>

    <div class="chart-labels">
      <div class="chart-labels-row">
        <p class="chart-label">{{ 'newInvestment.settings.developmentModel.today' | translate }}</p>
        <p class="chart-label">{{ totalYearsToInvest() / 2 | yearsTranslate }}</p>
        <p class="chart-label">{{ totalYearsToInvest() | yearsTranslate }}</p>
      </div>

      <div class="chart-data-container">
        <div class="chart-divider"></div>
        <div class="chart-data-row">
          @for (finalValue of getFinalValues(); track finalValue.name) {
            <div class="chart-data-item">
              <p class="chart-data-label">{{ finalValue.name }}</p>
              <p class="chart-data-value" [style.color]="finalValue.color">
                {{ finalValue.value | price: currencyCode }}
              </p>
            </div>
          }
        </div>
      </div>
    </div>
  }
}
